import { ApiCaller, Utils } from "../../config";
import { put } from "redux-saga/effects";
import CompanyOnboardingAction from "../actions/CompanyOnboardingAction";

export default class CompanyOnboardingMiddleware {
    static *OnboardCompany(params) {
        const { payload, cb } = params
        try {
            const res = yield ApiCaller.Post('/user/registration', payload);
            console.log({ onboardingresponse: res })
            if (res.status == 200 || res.status == 201) {
                yield put(CompanyOnboardingAction.CompanyOnboardSuccess());
                Utils.showMessage('success', res?.data?.message)
                cb && cb()
                window.location.href = res.data.data.subscriptionUrl
            }
        }
        catch (err) {
            yield put(CompanyOnboardingAction.CompanyOnboardFailure());
            console.log(err)
            Utils.showMessage('error', err?.response?.data?.message)
        }
    }

    static *ValidateCompanyUrl(params) {
        const { payload, cb } = params
        try {
            const res = yield ApiCaller.Post(`/company/url/validation?companyUrl=${"-"}&isExist=${"-"}`, payload);
            if (res.status == 200 || res.status == 201) {
                Utils.showMessage('success', res?.data?.message)
                cb && cb()
            }
        }
        catch (err) {
            yield put(CompanyOnboardingAction.CompanyOnboardFailure());
            console.log(err)
            Utils.showMessage('error', err?.response?.data?.message)
        }
    }
}